/**
 * FlexiPage Theme
 * Cryonix.cz
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license Commercial
 */
"use strict";
var util_1 = require('./util');
function bindForms() {
    var bindForm = function (formEl) {
        var working = false;
        var submitBtn = formEl.querySelector("button[type=submit]");
        var msgSuccess = formEl.querySelector(".form-messages .success");
        var msgInvalid = formEl.querySelector(".form-messages .invalid");
        var msgError = formEl.querySelector(".form-messages .error");
        formEl.addEventListener("submit", function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
            //Prevent double-submit
            if (working)
                return false;
            //Set state
            working = true;
            submitBtn.classList.add('loading');
            submitBtn.setAttribute('disabled', 'disabled');
            //Remove message classes
            msgSuccess.classList.remove('active');
            msgInvalid.classList.remove('active');
            msgError.classList.remove('active');
            //Prepare data
            var data = new FormData(formEl);
            //Send request
            util_1.apiRequest(util_1.httpMethodFromString(formEl.method), formEl.action, null, data, function (err, res, code) {
                working = false;
                submitBtn.classList.remove('loading');
                submitBtn.removeAttribute('disabled');
                if (err && code >= 400 && code < 500)
                    msgInvalid.classList.add('active');
                else if (err)
                    msgError.classList.add('active');
                else
                    msgSuccess.classList.add('active');
            });
            return false;
        });
    };
    var forms = document.querySelectorAll("form.form-editor-form");
    for (var i = 0; i < forms.length; i++)
        bindForm(forms.item(i));
}
exports.bindForms = bindForms;



/*****************
 ** WEBPACK FOOTER
 ** ./ts/form.ts
 ** module id = 5
 ** module chunks = 0
 **/